import React, { useEffect, useState } from "react";
import { Button, Col, Row, Stack, Table, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import inventoryApi from "../api/inventoryApi";

import moment from "moment"

import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";

const IEPList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [category, setAssesmentCategory] = useState("");
  const [period, setPeriod] = useState("");
  const [showCreateButton, setShowCreateButton] = useState(false); // Added By Jaseem     
  const [activeScheduler, setActiveScheduler] = useState(null); // Added By Jaseem        

  const createIEPRoles = ['Inclusive Teacher', 'Vocational Teacher', 'CBR Worker'];

  useEffect(() => {
    fetchAllAssessment();
    checkButtonVisibility();
    fetchActiveScheduler();
    
    // Check every 30 seconds for active scheduler
    const interval = setInterval(() => {
      checkButtonVisibility();
      fetchActiveScheduler();
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, []);

  // Check if Create IEP button should be visible based on scheduler
  const checkButtonVisibility = async () => {
    try {
      const result = await inventoryApi.checkIEPButtonVisibility();
      if (result && result.showButton !== undefined) {
        setShowCreateButton(result.showButton);
      }
    } catch (error) {
      console.error('Error checking button visibility:', error);
      // On error, default to hiding button
      setShowCreateButton(false);
    }
  };

  // Fetch active scheduler for banner display
  const fetchActiveScheduler = async () => {
    try {
      const activeSchedulers = await inventoryApi.fetchActiveSchedulers();
      if (activeSchedulers && activeSchedulers.length > 0) {
        setActiveScheduler(activeSchedulers[0]);
      } else {
        setActiveScheduler(null);
      }
    } catch (error) {
      console.error('Error fetching active scheduler:', error);
      setActiveScheduler(null);
    }
  };
  const fetchAllAssessment = async () => {
    setYear("")
    setMonth("")
    setPeriod("")
    setAssesmentCategory("")
    const result = await inventoryApi.fetchAssessmentsWithStudentsName();
    if (result) {
      //let tempBody = result.map((data, index) => ({ ...data, index: index + 1 }));
      setBody(result);
    } else {
      setBody([]);
    }
  }

  const findAssementWithYear = async () => {
    const result = await inventoryApi.findAssementWithYear({ year, month, period, category});
    if (result) {
      setBody(result);
    } else {
      setBody([]);
    }
  };
  // Create table headers consisting of 4 columns.
  const header = [

    {
      title: "Category", prop: "category", isFilterable: true,
      cell: (row) => (
        <Link
          to={"/assessments/" + row.id}
          state={row}
        >
          {row.category}
        </Link>
      )

    },
    { title: "Start Date", prop: "startdate", isFilterable: true, cell: (row) => moment(row.startdate).format("DD-MM-YYYY"), },
    { title: "End Date", prop: "enddate", isFilterable: true, cell: (row) => moment(row.enddate).format("DD-MM-YYYY"), },
    { title: "Status", prop: "status", isFilterable: true },
    { title: "Staff Name", prop: "staffname", isFilterable: true },
    { title: "Period", prop: "period", isFilterable: true },
    { title: "Students", prop: "studentnames", isFilterable: false }, // Added By Jaseem
    { title: "Remarks", prop: "remarks", isFilterable: true }, 
    // {
    //   title: "Actions",
    //   prop: "id",
    //   cell: (row) => (
    //     <Button className="btn-sm mx-2" onClick={() => editIEP({ row })}>
    //       <i className="fa-regular fa-pen-to-square"></i>
    //     </Button>
    //   ),
    // },
  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.

  const editIEP = (row) => {
    navigate(`/ieps/${row.row.id}/e`, { state: row });
  };

  const createIEP = () => {
    navigate(`/ieps/e`);
  };

  return (
    <Row className="g-0">
      <Col lg={2} className="mx-2">
        <Link className="nav-link">
          Assessments <i className="fa-solid fa-chevron-right"></i> IEP
        </Link>
      </Col>

      <Col lg={12} className="p-lg-4">
        {/* Blinking Banner for Active Scheduler */}
        {activeScheduler && (
          <Alert 
            variant="warning" 
            className="mb-3" 
            style={{ 
              borderLeft: '4px solid #ffa500',
              backgroundColor: '#fff3cd',
              animation: 'pulse 2s infinite'
            }}
          >
            <div className="d-flex align-items-center">
              <i className="fa-solid fa-calendar-days fa-2x me-3" style={{ color: '#ffa500' }}></i>
              <div className="flex-grow-1">
                <h6 className="mb-1" style={{ color: '#856404', fontWeight: 'bold' }}>
                  <i className="fa-solid fa-circle-exclamation me-2"></i>
                  IEP Schedule Active
                </h6>
                <p className="mb-0" style={{ color: '#856404' }}>
                  You can create IEP from <strong>{moment(activeScheduler.start_date).format("DD-MM-YYYY")}</strong> to <strong>{moment(activeScheduler.end_date).format("DD-MM-YYYY")}</strong>
                  {activeScheduler.targeted_audience === 'Specific' && (
                    <span className="ms-2">
                      {/* (For Selected Users Only) */}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </Alert>
        )}

        <DatatableWrapper
          body={body}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 10,
              options: [5, 10, 15, 20],
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              lg={3}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Filter />
            </Col>
            {
              /**
               * RMKM Phase 2 
               * Added by @jaseem
               * Date : 21 Apr 2025
               * Desc : IEP Filter work session or quarter wise
               */
            }
            <Col lg={6}>
              <Stack direction="horizontal" gap={3}>
                <select
                  className="form-control"
                  style={{width:'950px'}}
                  value={category}
                  onChange={(e) => setAssesmentCategory(e.target.value)}
                >
                  <option value="">Assesment Category</option>
                  <option value="FACP">FACP</option>
                  <option value="PHYSIO">PHYSIO</option>
                </select>
                <select
                  className="form-control"
                  value={period}
                  onChange={(e) => setPeriod(e.target.value)}
                >
                  <option value="">Select Period</option>
                  <option value="JAN TO JUNE">JAN TO JUNE</option>
                  <option value="JULY TO DEC">JULY TO DEC</option>
                  <option value="JUN TO MARCH">JAN TO MARCH</option>
                  <option value="JULY TO SEPT">JULY TO SEPT</option>
                  <option value="OCT TO DEC">OCT TO DEC</option>
                </select>
                <select
                  className="form-control"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  <option value="">Month</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(0, i).toLocaleString("default", { month: "long" })}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                >
                  <option value="" aria-readonly>Year</option>
                  {[...Array(2050 - 2020 + 1)].map((_, i) => (
                    <option key={i + 2020} value={i + 2020}>
                      {i + 2020}
                    </option>
                  ))}
                </select>
              </Stack>
            </Col>

            <Col lg={2}>
              <Stack direction="horizontal" gap={2}>
                <Button variant="primary" onClick={findAssementWithYear}>
                  Apply Filter
                </Button>
                <Button variant="success" onClick={() => { fetchAllAssessment() }}>
                  <i class="fa-solid fa-rotate-right"></i>
                </Button>
              </Stack>
            </Col>
            {/* End Filter Work */}

            {
              /**
               * RMKM Scheduler IEP Module
               * Added by @Auto
               * Date : Current
               * Desc : Show Create IEP button based on scheduler configuration
               */
              showCreateButton && (
                <Col
                  xs={12}
                  sm={6}
                  lg={1}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-sm"
                    variant="outline-primary"
                    onClick={() => createIEP(true)}
                  >
                    Create IEP
                  </Button>
                </Col>
              )
            }
          </Row>

          {/*  {body.length>0 ? */}
          <Table striped className="data-table">
            <TableHeader />
            <TableBody />
          </Table>
          {/* :
             ""} */}
          <Pagination />
        </DatatableWrapper>
      </Col>
    </Row>
  );
};

export default IEPList;
